import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { Modal } from '@telus-uds/components-web';
import Button from '../../orders/css';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { wirelessOrderForm } from '../../utils/constant';

const Continue = ({ orderData }) => {
  const { step } = orderData;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, continueLabel },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;
  const { locale, categoryName, id, isQuoteReference } = orderData;
  const history = useHistory();

  const handleModifyQuote = () => {
    history.push({
      pathname: `/${locale}/${categoryName}/${wirelessOrderForm}`,
      search: `?orderId=${id}&step=${step}&isEditing=true`
    });
    window.location.reload();
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>{continueLabel}</Button>
      <Modal
        heading={confirmationDialog}
        bodyText="Are you sure you want to continue with the order"
        confirmButtonText={confirmButtonLabel}
        // cancelButtonText={cancelButtonLabel}
        onConfirm={() => handleModifyQuote()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

Continue.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

Continue.actionType = 'mutation';

export default Continue;
